import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BodyMediumRegular, YStack } from 'smoothie';

import { centsToFormattedDollars } from '../../common/utils/formatting';

export const GenericDataTable = ({
    data,
    noRowsMessage = 'No rows found',
}: {
    data: object[] | null | undefined;
    noRowsMessage?: string;
}) => {
    if (data == null) {
        return null;
    }

    if (data.length === 0) {
        return <BodyMediumRegular>{noRowsMessage}</BodyMediumRegular>;
    }

    const columnKeys = Object.keys(data[0] as object);

    return (
        <YStack gap={8}>
            <DataTable value={data} size="small" tableStyle={{ width: '100%' }}>
                {columnKeys.map((key) =>
                    // TODO make font size smaller
                    key.toLowerCase().endsWith('_cents') ? (
                        <Column
                            key={key}
                            field={key}
                            header={key}
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
                            body={(x) => centsToFormattedDollars(x[key])}
                        />
                    ) : (
                        <Column key={key} field={key} header={key} />
                    ),
                )}
            </DataTable>
        </YStack>
    );
};
